module.exports = __webpack_public_path__ + "img/brt_ch_king_louen_leoncoeur_0.cf1b86a2.png";